import React from 'react'
import {useTranslation} from 'react-i18next'
import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

interface DiscardAnnotationChangesDialogProps {
  open: boolean
  onCancel: () => void
  onDiscard: () => void
  variant?: 'closeForm' | 'switchDelivery' // Default is 'closeForm'
}

const useStyles = makeStyles()(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      padding: '24px',
      width: '480px',
      maxWidth: '480px'
    }
  },
  title: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '24px',
    color: '#29333d',
    padding: 0,
    marginBottom: '24px'
  },
  content: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#29333d',
    padding: 0,
    marginBottom: '24px'
  },
  actions: {
    padding: 0,
    gap: '16px'
  },
  cancelButton: {
    flex: 1,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    padding: '12px 16px',
    borderColor: '#e8ecf0',
    color: '#29333d',
    borderRadius: '6px'
  },
  discardButton: {
    flex: 1,
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    padding: '12px 16px',
    backgroundColor: '#da0901',
    color: 'white',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: '#b90801'
    }
  }
}))

export const DiscardAnnotationChangesDialog: React.FC<DiscardAnnotationChangesDialogProps> = ({
  open,
  onCancel,
  onDiscard,
  variant = 'closeForm'
}) => {
  const {t} = useTranslation()
  const {classes} = useStyles()

  const message = variant === 'switchDelivery'
    ? t('leaveWithoutSavingMessageSwitchDelivery')
    : t('leaveWithoutSavingMessage')
  
  return (
    <Dialog 
      open={open} 
      onClose={onCancel} 
      className={classes.dialog}
      maxWidth={false}
    >
      <DialogTitle className={classes.title}>
        {t('leaveWithoutSavingTitle')}
      </DialogTitle>
      <DialogContent className={classes.content}>
        {message}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onCancel}
          variant="outlined"
          className={classes.cancelButton}
          data-test-id="discard-changes-cancel-button"
        >
          {t('cancel')}
        </Button>
        <Button
          onClick={onDiscard}
          variant="contained"
          className={classes.discardButton}
          data-test-id="discard-changes-confirm-button"
        >
          {t('discardChanges')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
